export const GLOBAL_CONTEXT = '__GLOBAL__';

/**
 * Shortest gap between two firings of a `repeatable` shortcut while its key is held. Matches
 * the pace a held key moved at before, which the OS repeat rate would otherwise outrun.
 */
export const REPEAT_INTERVAL_IN_MS = 100;
export const ACTIVATOR_KEY_REGEX =
  /^(?:[A-Z0-9\?]|ARROW(?:UP|DOWN|LEFT|RIGHT)|ESCAPE|ENTER|TAB|DELETE|BACKSPACE|SPACE)$/;
